module.exports = __webpack_public_path__ + "img/ph_telegram-logo-thin.bc9e585d.svg";